module.exports = __webpack_public_path__ + "static/Sylvera-05bad538d0e9dccda7aeb84235f5ba9f.jpg";